import { TRootState }                                   from 'Redux/Reducers';
import { filterObjectStore, queryFilter, IFilterProps } from 'Utils';
import { AppUser }                                      from 'Domain/Models';

export const getAppUsers = (state: TRootState, filter: null | IFilterProps<AppUser> = null) => {
  if (filter === null) {
    filter = queryFilter({ sorting: { by: 'id', order: 'ASC' } }) as IFilterProps<AppUser>;
  }

  return filterObjectStore(state.appUser.entries, filter);
};
